import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, Copy } from '@elparking/components'

const FreeCancel = () => <Box borderRadius='4px' background='success_light' display='inline-block' padding='4px 8px'>
    <Copy textWrap='no-wrap' as='span' padding='0px' fontSize='xxSmall' fontWeight='book' fontColor='success_dark'>
        <FormattedMessage defaultMessage='Cancelación gratuita' />
    </Copy>
</Box>

export default FreeCancel
